var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{on:{"click":function($event){_vm.skin = _vm.isDark ? 'light' : 'dark'}}},[_c('unicon',{attrs:{"wdith":"18","fill":("" + (_vm.isDark ? '#fff' : '#005baa')),"name":("" + (_vm.isDark ? 'sun' : 'moon'))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }